export enum ESituacaoCheque {
  PreDatado = 1,
  ACompensar = 2,
  Compensado = 3,
  Depositado = 4,
  Devolvido = 5
}
